import type { NavigationContent, NavigationItem } from '../schema';

export const primaryNavigation: readonly NavigationItem[] = [
  {
    id: 'home',
    name: 'Home',
    href: '/',
    description: 'Experience the heritage of Sree Silks',
    icon: 'home',
  },
  {
    id: 'products',
    name: 'Products',
    href: '/products',
    description: 'Browse the live public catalog and assisted-commerce selection',
    icon: 'collections',
  },
  {
    id: 'collections',
    name: 'Collections',
    href: '/collections',
    description: 'Explore signature sarees and ceremonial edits',
    icon: 'collections',
  },
  {
    id: 'wedding-gifting',
    name: 'Wedding Gifting',
    href: '/wedding-gifting',
    description: 'Curated gifting concierge for every ritual',
    icon: 'wedding',
  },
  {
    id: 'journey',
    name: 'Journey',
    href: '/journey',
    description: 'Five generations of silk craftsmanship',
    icon: 'journey',
  },
  {
    id: 'about',
    name: 'About',
    href: '/about',
    description: 'Learn about our atelier and ethos',
    icon: 'about',
  },
  {
    id: 'contact',
    name: 'Contact',
    href: '/contact',
    description: 'Consult with our stylists and gifting experts',
    icon: 'contact',
  },
] as const;

export const navigationContent = {
  primary: primaryNavigation,
  footer: primaryNavigation,
  menu: primaryNavigation,
} satisfies NavigationContent;
